import React, { useCallback, useState, useEffect } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"

import { useDispatch } from "react-redux";

import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

import { getProductUrl } from "../../../../../utils/product";
import { useHistory } from "react-router-dom";
import { SET_SIZE_CHART } from "../../../../../store/actions/global";
import { useSelector } from "react-redux";
import useOpenSizeChart from '../../../../hooks/open-sizechart'
import { getOriginalSize } from "../../../../utils/sensor";


const ProductSizeModule = props => {
    useStyles(classes)
    const history = useHistory()
    const { sizeChart, setSizeChart } = useOpenSizeChart()
    const {  selectedVariant, isDetail, selectedProduct, selectVariant, productVO } = props;
    const global = useSelector(state => state.global)
    const variants = selectedProduct?.variants
    const dispatch = useDispatch()
    const Intl = useIntl()
    let arr = []
    const [showSizeChart,setShowSizeChartLocal] = useState(false);

    // const getDescription = useCallback(desc => {
    //     return desc?.replace(/:[\w|\d|\-|(|)|\.]+;/g, function (value) { return '<span style="color:#999;margin-right: 5px;">' + value + ' </span>' })
    // }, [])


    const getDescription = useCallback((desc, selected) => {
		// const isOneSize = selected?.size?.toLowerCase() === 'one size'
		const descHtml  = desc?.replace(/:[\w|\d|\-|(|)|\.]+;/g, function (value) { return '<span style="color:#999;margin-right: 5px;">' + value + ' </span>' })
		// if(isOneSize){
		// 	return `
		// 		${descHtml}
		// 		<br/>
		// 		Regular US 4-6 90-120 lbs; Oversize US 6-8  90-145 lbs;
		// 	`
		// }
		return descHtml
	}, [])

    const isEnabled = v => {
        if (!v) return true
        return v.status === '1' && v.inventory > 0 || (v.domesticDelivery && v.domesticDelivery.enabled && v.domesticDelivery.inventory > 0)
    }

    useEffect(async ()=>{
        if(selectedProduct?.variants?.length > 1 && selectedProduct?.sizeChart2 && productVO?.taglia){
            // let response = await getProductTaglia(selectedProduct?.id);
            // if(response?.result){
                setShowSizeChartLocal(true);
            // }
        }
       
    },[])

    const setIframeMessage = () => {
        // dispatch(setProductIframe({
        //     title: Intl.formatMessage({ id: "sizing_help", defaultMessage: "Sizing Help" }),
        //     src: `/f/mobile/size?productId=${selectedProduct?.id}`
        // }));
        // dispatch(setShowSizeChart(true))
        // console.log(productVO)
        // dispatch({
        //     type:SET_SIZE_CHART,
        //     payload:{
        //         show: true,
        //         data: {
        //             products: productVO?.products,
        //             taglia: productVO?.taglia,
        //             productSizeData: productVO?.productSizeData
        //         }
        //     }
        // })
        setSizeChart({
            show: true,
            data: {
                selectedProduct: selectedProduct,
				products: productVO?.products,
				taglia: productVO?.taglia,
				productSizeData: productVO?.productSizeData
			}
        })
    }

    const changeVariant = (variant) => {
        // console.log("?")
        selectVariant(variant?.id)
        if(!isEnabled(variant)) {
            enabledShowEvent(variant)
        }
    }

    const enabledShowEvent = variant => {
        let flag = arr.find(item => item === variant?.id)
        if (!flag) {
            arr.push(variant?.id);
        }
    }

    const bigOrSmallEvent = (item) =>{
        let variantSize = selectedVariant?.size ?? null;

		if(window.GeekoSensors){
			window.GeekoSensors.Track('ELClick', {
				clicks:"ProductSize",
				size: getOriginalSize(variantSize),
				product_sku:selectedProduct?.parentSku,
				related_sku:item?.parentSku
			})
		}

        history.push(getProductUrl(item?.productId, selectedProduct?.name))

    }

    const getSizeLabel = size => {
        const countries = selectedProduct?.sizeChart2?.countryAndSizesList?.[0]?.map(c => c.country)
        const sizeDefaultCountry = countries?.find(c => c === global?.sizeDefaultCountry) || selectedProduct?.sizeChart2?.defaultCountry
        const sizes = selectedProduct?.sizeChart2?.countryAndSizesList?.find?.(s => s[0]?.size === size)
        if(sizes?.length > 0){
            return sizes?.find(s => s.country === sizeDefaultCountry)?.size || size
        }
        return size
    }

    return (
        <React.Fragment>
            <div className={classes.SizeContainer}>
                {
                    isDetail && selectedProduct?.associatedSizeProduct?.bigOrSmall === 0 && <div className={`${classes.SizeItem}`} onClick={() =>bigOrSmallEvent(selectedProduct.associatedSizeProduct)}>
                        <span>{selectedProduct.associatedSizeProduct?.title}</span>
                        <span className={classes.BigOrSmallIcon}></span>
                    </div>
                }

                {
                    variants && variants.map((variant, index) => <div className={`${classes.SizeItem} ${variant?.id === selectedVariant?.id ? `${classes.Active}` : ""} ${isEnabled(variant) ? "" : classes.Dashed}`} key={variant?.size2 + index} onClick={() => changeVariant(variant)}>
                        {getSizeLabel(variant?.size)}
                    </div>)
                }

                {
                    isDetail && selectedProduct?.associatedSizeProduct?.bigOrSmall === 1 && <div className={`${classes.SizeItem}`} onClick={() =>bigOrSmallEvent(selectedProduct.associatedSizeProduct)}>
                        <span>{selectedProduct.associatedSizeProduct?.title}</span>
                        <span className={classes.BigOrSmallIcon}></span>
                    </div>
                }
            </div>

            {
                selectedVariant?.description && <div className={`${classes.SizeDescription} ${!isDetail && classes.ModalSizeDescription}`}>
                    {
                        isDetail && <div className={classes.Font}><FormattedMessage id="product_measurements" defaultMessage="Product Measurements" /></div>
                    }
                    <span dangerouslySetInnerHTML={{ __html: getDescription(selectedVariant?.description, selectedVariant) }} className={classes.XpSizeTip}></span>

                    {
                        isDetail && selectedProduct?.sizeChart2 && showSizeChart &&  <div className={classes.SizeViewMore}>
                            <span onClick={setIframeMessage}><FormattedMessage id="view_size_information" defaultMessage="View more size information" /> {'>'}</span>
                        </div>
                    }
                </div>
            }

        </React.Fragment>
    )
}

export default ProductSizeModule;